// invoice-misc-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1i.send.cheerAlt': 'Plumma celebrando',
  'r1i.send.postAlt': 'Postplumma con un sobre',
  'r1i.main.parcelAlt': 'SuperPlumma con un paquete',
  'r1i.preview.subscription': 'Suscripción:',
  'r1i.preview.rental': 'Alquiler:',
});
